<template>
    <section class="mt-16">
      <v-breadcrumbs
          v-if="this.$root.$vuetify.theme.isDark"
          large
          :items="crumbs"
          divider="/"
          light
          :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        ></v-breadcrumbs>
        <v-breadcrumbs
          v-else
          :items="crumbs"
          divider="/"
          light
          :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-hard-hat</v-icon> <span>{{$t('shopping_request.crumb_edit')}}</span>
        </h1>
  
        <div class="mt-16">
          <v-progress-linear v-if="loading"
            indeterminate
            class="global-loader"
          ></v-progress-linear>
  
          <template v-if="loading">
            <v-row>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row class="mt-6" align="center" justify="space-around">
              <v-skeleton-loader
                  type="button"
                ></v-skeleton-loader>
            </v-row>
          </template>
          <ShoppingRequest @reload="refresh" v-else method="update" :shopping_request="shopping_request" @refresh="refresh" :style="this.$root.$vuetify.theme.isDark ? '' : 'background-color: rgba(255, 255, 255, 0.75) !important;'">
            </ShoppingRequest>
        </div>
    </section>
  </template>
  <script>
  import ShoppingRequest from '@/components/shopping_request/ShoppingRequest'
  import ShoppingRequestAPI from "@/api/ShoppingRequest.js";
  
  export default {
    components: {
        ShoppingRequest
    },
    beforeCreate(){
      document.title = "Report Lake - " + this.$t('shopping_request.crumb_edit');
    },
    data: () => ({
        shopping_request: {},
        loading:true
    }),
    mounted(){
      if(!this.$root.session.hasPermission(["super", "materials.update"])) {
        this.$router.push('/admin');
      }
  
      ShoppingRequestAPI.find(this.$route.params.id).then(({data}) => { this.shopping_request = data; this.loading = false;});
    },
    methods:{
      refresh(){
        ShoppingRequestAPI.find(this.$route.params.id).then(({data}) => { this.shopping_request = data; this.loading = false;});
      }
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: this.$t('menu.dashboard'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin',
            exact: true,
          },
          {
            text: this.$t('shopping_request.crumb_edit'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin/shopping-request',
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  